import "../../styles/art/GlobalImpactSection.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const logos = Array.from(
  { length: 24 },
  (_, i) => `/images/logos/${i + 1}.webp`
);

function GlobalImpactSection() {
  return (
    <section className="global-impact-section--art">
      <div className="global-impact-text">
        <h2 className="global-impact-heading">Đối tác Design24</h2>
        <p className="global-impact-description">
          Ghé thăm những công ty/đối tác nơi Design24 đã và đang hợp tác/làm
          việc
        </p>
      </div>

      <div className="global-impact-slider">
        <Swiper
          modules={[Autoplay]}
          spaceBetween={20}
          slidesPerView={6}
          loop={true}
          autoplay={{ delay: 0, disableOnInteraction: false }}
          speed={3000}
          allowTouchMove={true} // <-- thêm dòng này hoặc xóa dòng cũ
          breakpoints={{
            320: { slidesPerView: 2 },
            640: { slidesPerView: 4 },
            1024: { slidesPerView: 6 },
          }}
        >
          {/* Render logo từng cặp để chia 2 hàng */}
          {Array.from({ length: 12 }, (_, i) => (
            <SwiperSlide key={i}>
              <div className="logo-pair">
                <div className="logo-box">
                  <img
                    src={logos[i]}
                    alt={`logo-${i}`}
                    className="logo-img"
                  />
                </div>
                <div className="logo-box">
                  <img
                    src={logos[i + 12]}
                    alt={`logo-${i + 12}`}
                    className="logo-img"
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export default GlobalImpactSection;
